(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urgency-countdown"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('urgency-countdown-bar')) return;

    class UrgencyCountdownBar extends HTMLElement {
      connectedCallback() {
        const endDateValue = this.getAttribute('data-end-date');
        this.endDate = endDateValue ? new Date(endDateValue) : null;
        this.hideAfterExpiry = this.getAttribute('data-hide-after-expiry') === 'true';
        this.expiredText = this.getAttribute('data-expired-text') || '';

        this.hoursEl = this.querySelector('[data-urgency-hours]');
        this.minutesEl = this.querySelector('[data-urgency-minutes]');
        this.secondsEl = this.querySelector('[data-urgency-seconds]');
        this.timerEl = this.querySelector('[data-urgency-timer]');

        if (!this.endDate || isNaN(this.endDate.getTime())) {
          this.hidden = true;
          return;
        }

        this.tick();
        this.intervalId = window.setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.intervalId) window.clearInterval(this.intervalId);
      }

      tick() {
        const remainingMs = this.endDate.getTime() - Date.now();

        if (remainingMs <= 0) {
          if (this.intervalId) window.clearInterval(this.intervalId);

          if (this.hideAfterExpiry) {
            this.setAttribute('data-expired', 'true');
          } else if (this.timerEl && this.expiredText) {
            this.timerEl.textContent = this.expiredText;
          }

          return;
        }

        const totalSeconds = Math.floor(remainingMs / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }

    customElements.define('urgency-countdown-bar', UrgencyCountdownBar);
  })();

  } catch(e) { console.error(e); }
})();
})();
